import { Coffee } from 'lucide-react';

/** App footer — mirrors the osdu-insights layout footer. */
export const Footer = () => {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 mt-auto">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="OSDU Ops" className="h-6 w-6 rounded-full object-cover" />
            <span className="font-medium text-gray-700 dark:text-gray-300">OSDU Ops</span>
          </div>
          <div className="text-center text-sm text-gray-500 dark:text-gray-400">
            Developed and maintained by the{' '}
            <span className="font-medium text-gray-600 dark:text-gray-300">OSDU Platform Team</span>
            <span className="mx-2 text-gray-300 dark:text-gray-600">·</span>
            <span className="inline-flex items-center gap-1">
              Made with
              <Coffee className="h-3.5 w-3.5 text-amber-700 dark:text-amber-400" aria-label="coffee" />
            </span>
          </div>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            <span className="font-medium text-gray-600 dark:text-gray-300">Equinor</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
